import { render, staticRenderFns } from "./WebsiteProductView.vue?vue&type=template&id=6f4b5d18"
import script from "./WebsiteProductView.vue?vue&type=script&lang=js"
export * from "./WebsiteProductView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports